import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ReturnQuestionType } from "../../../../../../../projection/returnQuestion/returnQuestion.constants";
import { DOMAIN } from "../../../../../i18n/i18n";
import { ReturnQuestionItem } from "../ReturnQuestionItem";
import { style as hostRadioGroupReturnQuestionItemStyle } from "./HostRadioGroupReturnQuestionItem.style";

const HostRadioGroupReturnQuestionItem: ReturnQuestionItem<ReturnQuestionType.HOST_RADIO_GROUP> = ({
  returnQuestion,
  children,
  testID,
}) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const style = useMemo(() => hostRadioGroupReturnQuestionItemStyle(), []);

  return (
    <View style={style.wrapper} testID={testID}>
      {returnQuestion.translationKey && (
        <Text level={3} style={style.title} variant="action">
          {formatMessage({ id: returnQuestion.translationKey })}
        </Text>
      )}
      {children}
    </View>
  );
};

export { HostRadioGroupReturnQuestionItem };
